import { Link } from 'react-router-dom';
import '../styles/gallery.css';
import { useEffect, useState } from 'react';
import GalleryCard from '../components/GalleryCard';
import Masonry from 'react-masonry-css';
import { Fade } from 'react-reveal';

window.onload = () => {
    // console.log('this is working');
    // const grid = document.querySelector('.masonry-grid');
    // const masonry = new Masonry(grid, {
    //     itemSelector: '.masonry-grid-item',
    //     gutter: 10
    // });
}

const Gallery = () => {

    const [projectList, setProjectList] = useState([]);

    const SERVER_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_DEV_SERVER_URL : process.env.REACT_APP_PROD_SERVER_URL;

    const getProjectList = () => {
        fetch(`${SERVER_URL}/getProjects`, {
            method: 'GET',
            headers: {
                "content-encoding": null,
                "gzip": true
            }
        })
            .then(result => result.json())
            .then((data) => { setProjectList(data) })
            .catch((err) => console.log("error in fetching data - " + err));
    }

    const breakpointColumnsObj = {
        default: 3,
        1200: 3,
        992: 2,
        576: 1
    };

    useEffect(() => {
        getProjectList();
    }, []);

    return (
        <div className="container-fluid gallery px-0">
            <div className="">
                <Fade>
                    <img className="img-fluid" src="/assets/images/home/heroimg1.jpg" alt="" />
                </Fade>
            </div>

            <div className="container">

                <Fade delay={500}>
                    <p className='heading-1 nav-link p-3 p-md-5 m-0' align="center">
                        GALLERY
                    </p>
                </Fade>

                {/* <nav className="navbar navbar-expand justify-content-center py-5">
                    <ul className='navbar-nav'>
                        <li className='nav-item'><Link className='heading-1 nav-link px-2 px-md-5'>RESIDENTIAL</Link></li>
                        <li className='nav-item'><Link className='heading-1 nav-link px-2 px-md-5'>BUSINESS</Link></li>
                        <li className='nav-item'><Link className='heading-1 nav-link px-2 px-md-5'>COMMERCIAL</Link></li>
                    </ul>
                </nav> */}

                { /* Start - Masonry Grid for projects */}

                <div id='gallery-masonry'>
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column"
                    >
                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/2.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/10.png" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/11.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/14.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/5.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/6.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        {/* DYNAMIC GRID */}
                        {
                            projectList.length > 0 &&
                            projectList.map(
                                (proj, index) =>
                                    <Fade key={index}>
                                        <GalleryCard proj={proj} />
                                    </Fade>
                            )
                        }
                        {/* DYNAMIC GRID */}

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/4.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/9.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/12.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/13.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>

                        <div className="masonry-grid-item">
                            <Link
                                to={``}
                                style={{ textDecoration: 'none' }}
                            >
                                <img loading="lazy" className="img-fluid gallery-project-image"
                                    src="/assets/images/gallery/7.jpg" alt="" />
                                <figcaption className="img-caption content-0 chocolate"></figcaption>
                            </Link>
                        </div>


                    </Masonry>
                </div>

            </div>
        </div>
    );
}

export default Gallery;